import { render } from "./Medicalhistorycrosstabulation.vue?vue&type=template&id=69a6f39a&scoped=true"
import script from "./Medicalhistorycrosstabulation.js?vue&type=script&lang=js"
export * from "./Medicalhistorycrosstabulation.js?vue&type=script&lang=js"

import "./Medicalhistorycrosstabulation.vue?vue&type=style&index=0&id=69a6f39a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a6f39a"]])

export default __exports__